import { render } from "./AccordionEdit.vue?vue&type=template&id=5a2bfb6b&scoped=true"
import script from "./AccordionEdit.vue?vue&type=script&lang=js"
export * from "./AccordionEdit.vue?vue&type=script&lang=js"

import "./AccordionEdit.vue?vue&type=style&index=0&id=5a2bfb6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2bfb6b"],['__file',"src/components/accordion/AccordionEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a2bfb6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a2bfb6b', __exports__)) {
    api.reload('5a2bfb6b', __exports__)
  }
  
  module.hot.accept("./AccordionEdit.vue?vue&type=template&id=5a2bfb6b&scoped=true", () => {
    api.rerender('5a2bfb6b', render)
  })

}


export default __exports__